import { ITrackingProductPageBaseParameters } from './baseParameters';

export type ITrackingFillItemsParameters = Pick<
  ITrackingProductPageBaseParameters,
  'productUid' | 'productName' | 'productProviderName'
>;

export const fillItems = (parameters: ITrackingFillItemsParameters) => {
  const { productName, productUid, productProviderName } = parameters;

  return {
    items: [
      {
        //core item attributes
        item_id: productUid,
        item_name: productName,
        item_brand: productProviderName,
        index: 1,

        // TODO: implement if needed
        // //additional attribtues
        // 'deal_status':true/false,
        // 'promotion':(dynamic),

        // //for transactional items
        // 'quantity':(dynamic), <= can skip if quantity = 1
        // 'price':$price_item,
        // 'currency':HKD/SGD/TWD/PHP,
        // 'discount':$discount,

        // //other optional fields
        // 'coupon': '(dynamic)'
      },
    ],
  } as const;
};
